import { Component } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CommonService } from 'src/app/services/common/common.service'

@Component({
  selector: 'app-repository-search',
  templateUrl: './data-repository-search.component.html',
  styleUrls: ['./data-repository-search.component.scss']
})
export class DataRepositorySearchComponent {
  constructor(private cs: CommonService) {}
  onCategorySelected(event: any) {}

  navigateToQuickSelectPage() {
    const quickLinkPage = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${GlobalConstants.ROUTING.QUICK_SELECT}`
    this.cs.route(quickLinkPage)
  }

  exit() {
    const quickLinkPage = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${GlobalConstants.ROUTING.QUICK_SELECT}`
    this.cs.route(quickLinkPage)
  }
}
